import { useParams } from 'react-router-dom';

const NoCompanyOverviewData = () => {
  const { number, clientNumber } = useParams<{ number: string; clientNumber: string }>();

  return (
    <div className="flex size-full flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center">
        <div className="text-center text-marveri-light-silver">
          <p className="processing-text flex h-[37px] justify-center text-xl font-semibold">
            No Company Overview Data Found
          </p>
          <p className="mt-2 text-sm text-N400">
            We couldn&apos;t find any company overview data in this client matter.
          </p>
          <a
            href={`/client/${clientNumber}/matter/${number}/dataroom`}
            className="mt-6 inline-block rounded-md px-4 py-2 text-white"
          >
            Return to Document List
          </a>
        </div>
      </div>
    </div>
  );
};

export default NoCompanyOverviewData;
